<template>
  <a-modal
    class="modal-content"
    :title="`${form.id ? '编辑' : '添加'}${title}`"
    :width="700"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <a-form-model
      ref="ruleForm"
      :labelCol="{ span: 2 }"
      :wrapperCol="{ span: 22 }"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item label="标题" prop="title">
        <a-input v-model="form.title" placeholder="请输入标题" />
      </a-form-model-item>
      <a-row :gutter="0">
        <a-col :span="10" style="padding-left: 3px">
          <a-form-model-item
            label="图片"
            prop="coverUrl"
            :labelCol="{ span: 5 }"
            :wrapperCol="itemWrapperCol"
            class="coverUrl-item"
          >
            <j-image-upload
              ref="coverRef"
              accept=".png,.jpg,.jpeg"
              v-model="form.coverUrl"
              :otherData="{
                compress: 1,
              }"
              bizPath="dayOath"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item
            label="带二维码图片"
            prop="url"
            :labelCol="itemLabelCol"
            :wrapperCol="itemWrapperCol"
            class="coverUrl-item"
          >
            <j-image-upload
              ref="coverRef"
              accept=".png,.jpg,.jpeg"
              v-model="form.url"
              :otherData="{
                compress: 1,
              }"
              bizPath="dayOath"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { postAction, putAction } from '@/api/manage'
import { getStoreFileUrl } from '@/utils/util'
import moment from 'moment'
import JImageUpload from '@comp/jeecg/JImageUpload.vue'

export default {
  name: 'DaySigningModal',
  components: { JImageUpload },
  mixins: [JeecgListMixin],
  props: {
    title: {
      type: String,
      default: '日签',
    },
  },
  data() {
    return {
      visible: false,
      form: {},
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'change' }],
        coverUrl: [{ required: true, message: '请上传封面', trigger: 'change' }],
        url: [{ required: true, message: '请上传带二维码图片', trigger: 'change' }],
      },
      itemLabelCol: { span: 10 },
      itemWrapperCol: { span: 12 },
      currEvalInfo: {},
      fileList: [],
      activeKey: '5',
      isShowDetails: false,
      templateUrl: '',
    }
  },
  methods: {
    showModal(data = {}) {
      this.form = data
      this.visible = true
      this.fileList = []
    },
    hideModal() {
      this.visible = false
      this.form = {}
      this.fileList = []
    },
    async handleOk() {
      const params = {
        ceremonyId: this.form.ceremonyId,
        ceremonyItemId: this.form.ceremonyItemId,
        id: this.form.id,
        title: this.form.title,
        coverUrl: this.form.coverUrl,
        url: this.form.url,
        contentType: this.form.contentType,
      }
      if (this.fileList.length > 0) {
        params.url = this.fileList[this.fileList.length - 1].url
      }
      console.log('参数--', params)
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const res = params.id
            ? await putAction('/ceremonyItemContent/edit', params)
            : await postAction('/ceremonyItemContent/add', params)
          if (res.success) {
            this.$message.success(res.message)
            this.hideModal()
            this.$emit('refreshData')
          } else {
            this.$message.error(res.message || '保存失败')
          }
        }
      })
    },
    handleChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.message
        }
        return file
      })
      this.fileList = fileList
      console.log('fileList', fileList)
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-modal-header {
    border-bottom: none;
  }
  /deep/ .ant-modal-body {
    padding: 0 24px 10px;
  }
  ///deep/ .ant-upload {
  //  height: 149px;
  //}
  /deep/ .ant-upload-picture-card-wrapper {
    width: auto;
  }
  .coverUrl-item {
    /deep/ .ant-upload {
      width: 200px;
    }
  }
}
</style>
